import React, { useState } from 'react';
import { SaveIcon, RefreshCwIcon, ShieldIcon, BellIcon, UserIcon, MailIcon, SettingsIcon } from 'lucide-react';
export function AdminSettings() {
  const [generalSettings, setGeneralSettings] = useState({
    siteName: 'حقوق الزوجين في الإسلام',
    siteDescription: 'منصة توعوية عن حقوق الزوجين في الإسلام',
    contactEmail: 'admin@example.com',
    supportPhone: '0777123456',
    enableRegistration: true,
    maintenanceMode: false
  });
  const [notificationSettings, setNotificationSettings] = useState({
    emailNotifications: true,
    newConsultationAlert: true,
    newContactMessageAlert: true,
    dailySummary: false,
    weeklySummary: true
  });
  const [securitySettings, setSecuritySettings] = useState({
    twoFactorAuth: false,
    sessionTimeout: 60,
    maxLoginAttempts: 5,
    passwordExpiry: 90
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const handleGeneralSettingsChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value,
      type
    } = e.target;
    setGeneralSettings(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
    }));
  };
  const handleNotificationSettingsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      checked
    } = e.target;
    setNotificationSettings(prev => ({
      ...prev,
      [name]: checked
    }));
  };
  const handleSecuritySettingsChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value,
      type
    } = e.target;
    setSecuritySettings(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : type === 'number' ? parseInt(value) : value
    }));
  };
  const saveSettings = () => {
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      // Save to localStorage for demo purposes
      localStorage.setItem('adminGeneralSettings', JSON.stringify(generalSettings));
      localStorage.setItem('adminNotificationSettings', JSON.stringify(notificationSettings));
      localStorage.setItem('adminSecuritySettings', JSON.stringify(securitySettings));
      setIsSubmitting(false);
      setSuccessMessage('تم حفظ الإعدادات بنجاح');
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
    }, 1000);
  };
  return <div className="bg-white rounded-lg shadow-md p-6" data-id="element-164">
      <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4" data-id="element-165">
        <h2 className="text-xl font-bold text-sky-900" data-id="element-166">إعدادات النظام</h2>
        <button onClick={saveSettings} disabled={isSubmitting} className="px-4 py-2 bg-sky-600 text-white rounded-md hover:bg-sky-700 transition-colors duration-200 flex items-center" data-id="element-167">
          {isSubmitting ? <>
              <div className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin ml-2" data-id="element-168"></div>
              <span data-id="element-169">جاري الحفظ...</span>
            </> : <>
              <SaveIcon className="h-4 w-4 ml-2" data-id="element-170" />
              <span data-id="element-171">حفظ الإعدادات</span>
            </>}
        </button>
      </div>
      {successMessage && <div className="mb-6 bg-green-100 text-green-800 p-3 rounded-md flex items-center" data-id="element-172">
          <span data-id="element-173">{successMessage}</span>
        </div>}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-174">
        {/* General Settings */}
        <div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden" data-id="element-175">
          <div className="p-4 bg-slate-50 border-b border-slate-200 flex items-center" data-id="element-176">
            <SettingsIcon className="h-5 w-5 text-slate-600 ml-2" data-id="element-177" />
            <h3 className="font-bold text-slate-800" data-id="element-178">الإعدادات العامة</h3>
          </div>
          <div className="p-4 space-y-4" data-id="element-179">
            <div data-id="element-180">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-181">
                اسم الموقع
              </label>
              <input type="text" name="siteName" value={generalSettings.siteName} onChange={handleGeneralSettingsChange} className="w-full px-3 py-2 border border-slate-200 rounded-md focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500" data-id="element-182" />
            </div>
            <div data-id="element-183">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-184">
                وصف الموقع
              </label>
              <textarea name="siteDescription" value={generalSettings.siteDescription} onChange={handleGeneralSettingsChange} className="w-full px-3 py-2 border border-slate-200 rounded-md focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500" rows={3} data-id="element-185"></textarea>
            </div>
            <div data-id="element-186">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-187">
                البريد الإلكتروني للتواصل
              </label>
              <input type="email" name="contactEmail" value={generalSettings.contactEmail} onChange={handleGeneralSettingsChange} className="w-full px-3 py-2 border border-slate-200 rounded-md focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500" data-id="element-188" />
            </div>
            <div data-id="element-189">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-190">
                رقم هاتف الدعم الفني
              </label>
              <input type="text" name="supportPhone" value={generalSettings.supportPhone} onChange={handleGeneralSettingsChange} className="w-full px-3 py-2 border border-slate-200 rounded-md focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500" data-id="element-191" />
            </div>
            <div className="flex items-center" data-id="element-192">
              <input type="checkbox" name="enableRegistration" id="enableRegistration" checked={generalSettings.enableRegistration} onChange={e => setGeneralSettings(prev => ({
              ...prev,
              enableRegistration: e.target.checked
            }))} className="h-4 w-4 text-sky-600 focus:ring-sky-500 border-slate-300 rounded ml-2" data-id="element-193" />
              <label htmlFor="enableRegistration" className="text-sm text-slate-700" data-id="element-194">
                تفعيل تسجيل المستخدمين الجدد
              </label>
            </div>
            <div className="flex items-center" data-id="element-195">
              <input type="checkbox" name="maintenanceMode" id="maintenanceMode" checked={generalSettings.maintenanceMode} onChange={e => setGeneralSettings(prev => ({
              ...prev,
              maintenanceMode: e.target.checked
            }))} className="h-4 w-4 text-sky-600 focus:ring-sky-500 border-slate-300 rounded ml-2" data-id="element-196" />
              <label htmlFor="maintenanceMode" className="text-sm text-slate-700" data-id="element-197">
                وضع الصيانة
              </label>
            </div>
          </div>
        </div>
        {/* Notification Settings */}
        <div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden" data-id="element-198">
          <div className="p-4 bg-slate-50 border-b border-slate-200 flex items-center" data-id="element-199">
            <BellIcon className="h-5 w-5 text-slate-600 ml-2" data-id="element-200" />
            <h3 className="font-bold text-slate-800" data-id="element-201">إعدادات الإشعارات</h3>
          </div>
          <div className="p-4 space-y-4" data-id="element-202">
            <div className="flex items-center" data-id="element-203">
              <input type="checkbox" name="emailNotifications" id="emailNotifications" checked={notificationSettings.emailNotifications} onChange={handleNotificationSettingsChange} className="h-4 w-4 text-sky-600 focus:ring-sky-500 border-slate-300 rounded ml-2" data-id="element-204" />
              <label htmlFor="emailNotifications" className="text-sm text-slate-700" data-id="element-205">
                تفعيل الإشعارات عبر البريد الإلكتروني
              </label>
            </div>
            <div className="flex items-center" data-id="element-206">
              <input type="checkbox" name="newConsultationAlert" id="newConsultationAlert" checked={notificationSettings.newConsultationAlert} onChange={handleNotificationSettingsChange} className="h-4 w-4 text-sky-600 focus:ring-sky-500 border-slate-300 rounded ml-2" data-id="element-207" />
              <label htmlFor="newConsultationAlert" className="text-sm text-slate-700" data-id="element-208">
                تنبيه عند وجود طلب استشارة جديد
              </label>
            </div>
            <div className="flex items-center" data-id="element-209">
              <input type="checkbox" name="newContactMessageAlert" id="newContactMessageAlert" checked={notificationSettings.newContactMessageAlert} onChange={handleNotificationSettingsChange} className="h-4 w-4 text-sky-600 focus:ring-sky-500 border-slate-300 rounded ml-2" data-id="element-210" />
              <label htmlFor="newContactMessageAlert" className="text-sm text-slate-700" data-id="element-211">
                تنبيه عند وجود رسالة تواصل جديدة
              </label>
            </div>
            <div className="flex items-center" data-id="element-212">
              <input type="checkbox" name="dailySummary" id="dailySummary" checked={notificationSettings.dailySummary} onChange={handleNotificationSettingsChange} className="h-4 w-4 text-sky-600 focus:ring-sky-500 border-slate-300 rounded ml-2" data-id="element-213" />
              <label htmlFor="dailySummary" className="text-sm text-slate-700" data-id="element-214">
                ملخص يومي للنشاطات
              </label>
            </div>
            <div className="flex items-center" data-id="element-215">
              <input type="checkbox" name="weeklySummary" id="weeklySummary" checked={notificationSettings.weeklySummary} onChange={handleNotificationSettingsChange} className="h-4 w-4 text-sky-600 focus:ring-sky-500 border-slate-300 rounded ml-2" data-id="element-216" />
              <label htmlFor="weeklySummary" className="text-sm text-slate-700" data-id="element-217">
                ملخص أسبوعي للنشاطات
              </label>
            </div>
          </div>
        </div>
        {/* Security Settings */}
        <div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden" data-id="element-218">
          <div className="p-4 bg-slate-50 border-b border-slate-200 flex items-center" data-id="element-219">
            <ShieldIcon className="h-5 w-5 text-slate-600 ml-2" data-id="element-220" />
            <h3 className="font-bold text-slate-800" data-id="element-221">إعدادات الأمان</h3>
          </div>
          <div className="p-4 space-y-4" data-id="element-222">
            <div className="flex items-center" data-id="element-223">
              <input type="checkbox" name="twoFactorAuth" id="twoFactorAuth" checked={securitySettings.twoFactorAuth} onChange={e => setSecuritySettings(prev => ({
              ...prev,
              twoFactorAuth: e.target.checked
            }))} className="h-4 w-4 text-sky-600 focus:ring-sky-500 border-slate-300 rounded ml-2" data-id="element-224" />
              <label htmlFor="twoFactorAuth" className="text-sm text-slate-700" data-id="element-225">
                تفعيل التحقق الثنائي
              </label>
            </div>
            <div data-id="element-226">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-227">
                مدة انتهاء الجلسة (بالدقائق)
              </label>
              <input type="number" name="sessionTimeout" value={securitySettings.sessionTimeout} onChange={e => setSecuritySettings(prev => ({
              ...prev,
              sessionTimeout: parseInt(e.target.value)
            }))} className="w-full px-3 py-2 border border-slate-200 rounded-md focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500" data-id="element-228" />
            </div>
            <div data-id="element-229">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-230">
                الحد الأقصى لمحاولات تسجيل الدخول
              </label>
              <input type="number" name="maxLoginAttempts" value={securitySettings.maxLoginAttempts} onChange={e => setSecuritySettings(prev => ({
              ...prev,
              maxLoginAttempts: parseInt(e.target.value)
            }))} className="w-full px-3 py-2 border border-slate-200 rounded-md focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500" data-id="element-231" />
            </div>
            <div data-id="element-232">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-233">
                مدة صلاحية كلمة المرور (بالأيام)
              </label>
              <input type="number" name="passwordExpiry" value={securitySettings.passwordExpiry} onChange={e => setSecuritySettings(prev => ({
              ...prev,
              passwordExpiry: parseInt(e.target.value)
            }))} className="w-full px-3 py-2 border border-slate-200 rounded-md focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500" data-id="element-234" />
            </div>
          </div>
        </div>
      </div>
    </div>;
}